<template>
    <div
        id="story"
        style="margin-top: 8rem;"
        :class="[{ exclusive: story.exclusive }]"
    >
        <div class="container" id="story-section-1">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="text-center pb-3">{{ story.title }}</h1>
                    <div class="row text-center pb-3">
                        <div class="col-6 text-right">
                            By {{ story.author }}
                        </div>
                        <div class="col-6 text-left">{{ published }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div id="story-section-2">
            <img id="cover-img" :src="img" alt="" />
        </div>
        <div class="container" id="story-section-3">
            <div id="popup-exclusive" v-if="story.exclusive && !this.hero">
                <becomeaheronow />
            </div>
            <div class="row">
                <div class="col-md-1" id="share-buttons">
                    <div class="a2a_kit a2a_kit_size_45 a2a_default_style">
                        <a class="a2a_button_facebook"></a>
                        <a class="a2a_button_twitter"></a>
                        <a class="a2a_button_pinterest"></a>
                        <a class="a2a_button_google_gmail"></a>
                        <a class="a2a_button_whatsapp"></a>
                        <a
                            class="a2a_dd"
                            href="https://www.addtoany.com/share"
                        ></a>
                    </div>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-9">
                    <h1
                        id="story-title"
                        style="overflow: hidden; max-width: 90ch;"
                    >
                        {{ story.title }}
                    </h1>
                    <p id="first-body" v-html="first_body"></p>
                    <img
                        class="w-100"
                        v-if="story.exclusive && !this.hero"
                        src="/images/pages/hide-it.jpg"
                        alt=""
                        style="pointer-events: none; user-select: none;"
                    />

                    <div id="custom-hline" class="row">
                        <div class="col-5">
                            <hr />
                        </div>
                        <div class="col-2 pr-0 pl-0">
                            <div class="three-dots">
                                <span class="dots-small"></span>
                                <span class="dots-big"></span>
                                <span class="dots-small"></span>
                            </div>
                        </div>
                        <div class="col-5">
                            <hr />
                        </div>
                    </div>
                </div>

                <div class="col-md-1"></div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import VueMobileDetection from "vue-mobile-detection";
Vue.use(VueMobileDetection);

export default {
    props: ["story", "hero"],
    data() {
        return {
            title: "",
            first_body: "",
            published: "",
            author: "",
            img: "",
            adopt_member: 0
        };
    },
    created() {
        this.showStory();
    },
    mounted() {
        // this.adopt_member = this.hero;
        // const content = $("#first-body").children();
        // const midLength = parseInt(content.length / 2);
        // const blur_img = this.adopt_member == 1 ? "filter:blur(8px);" : "";
        // content
        //     .eq(midLength)
        //     .after(
        //         '<img width="100%;" style="float:left;position:relative;top:100; margin-top:20px;margin-bottom:20px;' +
        //             blur_img +
        //             '" src="' +
        //             this.img +
        //             '">'
        //     );
        // if (this.adopt_member == 1) {
        //     for (let eq = 3; eq <= content.length; eq++) {
        //         content.eq(eq).css("filter", "blur(5px)");
        //     }
        // }
    },
    methods: {
        showStory() {
            this.published = moment(this.story.published_at).format(
                "DD MMMM YYYY"
            );
            // create jquery object from this.stroy.body
            const $body = $($.parseHTML(`<div>${this.story.body}</div>`));

            const $h1 = $body.find("h1:has(strong:has(em))");
            // check if published is less than 3 April 2023
            if (moment(this.story.published_at).isBefore("2023-04-03")) {
                // change the font size in h1
                $h1.css("font-size", "1.4rem");
                $h1.css("line-height", "1.3");
            }
            const $h1NotBold = $body.find("h1:has(em)");
            // wrap iframe in $body with div class .videoWrapper
            $body.find("iframe").wrap('<div class="videoWrapper"></div>');
            // check if published is less than 3 April 2023
            if (moment(this.story.published_at).isBefore("2023-04-03")) {
                // change the font size in h1
                $h1NotBold.css("font-size", "1.4rem");
                $h1NotBold.css("line-height", "1.3");
            }

            this.first_body = $body.html();

            // this.adopt_member = this.story.exclusive == 1 ? (this.hero == 1 ? 0 : 1) : 0;
        }
    }
};
</script>

<style scoped>
p::v-deep img {
    max-width: 100%;
    height: auto;
}
p::v-deep .videoWrapper {
    position: relative;
    padding-bottom: 56.25%;
    /* 16:9 */
    padding-top: 25px;
    height: 0;
}

p::v-deep .videoWrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.story-show h1.text-center.pb-5 {
    font-family: WWF;
    font-size: 3rem;
    line-height: 3rem;
    text-transform: uppercase;
}

#story-section-1 {
    margin-top: 2rem;
    margin-bottom: 2rem;
}

#story-section-2 {
    margin: 0;
    padding: 0;
}
#story-section-2 #cover-img {
    max-width: 100%;
    width: 100%;
    height: auto;
    background-color: lightgray;
}
#story-section-3 #story-title {
    text-align: left;
    font-weight: normal;
    font-family: WWF;
    text-transform: uppercase;
    font-size: 2.5rem;
    line-height: 2.5rem;
    margin-top: 70px;
    margin-bottom: 20px;
}
#story-section-3 #first-body {
    margin-bottom: 50px;
    font-size: 0.9rem;
}
.exclusive #first-body {
    position: relative;
    /* filter: blur(4px); */
}
.exclusive #first-body:before {
    position: absolute;
    content: "";
    bottom: 0;
    width: 100%;
    left: 0;
    /* filter: blur(100px); */
}
#story-section-3 #second-body {
    margin-top: 50px;
    font-size: 0.9rem;
}
#story-section-3 #note {
    margin-top: 50px;
    margin-bottom: 50px;
    font-size: 0.9rem;
}
#story-section-3 hr {
    border: 1px solid lightgray;
    margin-top: 10px;
    margin-bottom: 0;
}
#story-section-3 #custom-hline {
    margin-top: 4rem;
    margin-bottom: 7rem;
}

.three-dots {
    text-align: center;
}
.three-dots .dots-small {
    width: 10px;
    height: 10px;
    margin-top: 2.5px;
    margin-bottom: 2.5px;
}
.three-dots .dots-big {
    width: 15px;
    height: 15px;
}
.three-dots span {
    border-radius: 50%;
    background: lightgray;
    display: inline-block;
    margin: 0 0.45vw;
}
#popup-exclusive {
    position: absolute;
    top: 55rem;
    z-index: 2;
}
#share-buttons div {
    margin-top: 70px;
}
#share-buttons div a {
    margin: 10px 1px;
}
@media only screen and (max-width: 768px) {
    #popup-exclusive {
        top: 65rem;
        left: 0;
    }
    #story-section-3 .row .col-md-9 {
        padding-right: 1.5rem;
        padding-left: 1.5rem;
    }
}
</style>
